
export const SET_REMARK = 'SET_REMARK';

export const setRemark = (remark) => ({
    type: SET_REMARK,
    payload: remark,
});

export const SET_USERS = 'SET_USERS';

export const setUser = (user) => ({
    type: SET_USERS,
    payload: user,
});

export const LOGOUT = 'LOGOUT';

export const logout = () => ({
    type: LOGOUT,
});